import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateCustomStock,
  addCustomStock,
  deleteCustomStock,
} from "../slices/customStocksSlice";
import { setCustomStocks } from "../slices/sharedSlice";
import { api } from "../utils/api";

function* refreshCustomStocksSaga() {
  try {
    const { data } = yield call(api.getCustomStocks);
    yield put(setCustomStocks(data));
    console.log("Custom Stocks refreshed:", data);
  } catch (error) {
    console.error("Failed to refresh Custom Stocks", error);
  }
}

export default function* customStocksSaga() {
  yield takeLatest(
    [updateCustomStock.type, addCustomStock.type, deleteCustomStock.type],
    refreshCustomStocksSaga
  );
}
